module.exports = __webpack_public_path__ + "static/media/app-4@2x.80ed3070.png";